import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-delete-space-confirm',
  templateUrl: './delete-space-confirm.component.html',
  styleUrls: ['./delete-space-confirm.component.scss']
})
export class DeleteSpaceConfirmComponent implements OnInit, OnChanges {
  @Input() singleSpaceData;
  deleteSpaceError;
  deleteSpaceSuccess;
  // @Output() deleteSpaceEmit = new EventEmitter();
  @Output() modalCloseEmit = new EventEmitter();

  isSubmitted = false;
  accessToken: any;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleSpaceData && changes.singleSpaceData.currentValue) {
      this.resetErrorValues();
    }
    // if (changes.deleteSpaceSuccess && changes.deleteSpaceSuccess.currentValue) {
    //   this.isSubmitted = false;
    //   setTimeout(() => {
    //     this.modalCloseEmit.emit(true);
    //   }, 2000);
    // }
  }

  deleteSpace(space) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteSpaceEmit(space);
  }

  deleteSpaceEmit(space) {
    this.deleteSpaceError = undefined;
    this.memberService.deleteMemberSpace({
      Authorization: this.accessToken,
      id: space.uuid
    }).subscribe(response => {
      this.deleteSpaceSuccess = 'Space was deleted successfully.';
      setTimeout(() => {
        this.modalCloseEmit.emit(true);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteSpaceError = err.error.error;
      } else {
        this.deleteSpaceError = 'There was error while deleting space.';
      }
    });
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSpaceSuccess = undefined;
    this.deleteSpaceError = undefined;
  }

}
